 <template>
  <div class="app-home">
    <!-- banner -->
    <el-carousel :interval="5000" arrow="never">
      <el-carousel-item class="firstcarousel"  v-for="item in slider"
          :key="item"
          :style="{backgroundImage: ' url('+item.image+')'}" >
        <div class="container">
          <div class="row">
            <div class="sliderinfo">
              <div v-html="item.description"></div>
              <!-- <h5>Come test-drive the</h5>
              <h2>
                New 7- Seat
                <span>Peugeot 5008 Suv</span>
              </h2>
              <p>
                Introducing the latest
                <span>Peugeot 5008</span> series in Ghana. Be amongst the first to test drive this new model.
              </p> -->
              <div style="margin-top:13%">
                <el-button
                  type="info"
                  style="border: 1.5px solid #BCBCBC;background:transparent"
                  @click="contact"
                >
                  Start Your Journey
                  <i class="el-icon-arrow-right" style="padding-left:5%"></i>
                </el-button>
                <router-link :to="'/'+item.mask ">

                <!-- <el-button class="text text-uppercase" type="text" v-if="item.name!='MB CV'">  DISCOVER {{item.name}}</el-button> -->
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>

        <!-- <el-carousel-item class="secondcarousel">
        <div class="container">
          <div class="row">
            <div class="sliderinfo">
           
              <h2>
                Comfort<br>
                <span>is the new cool</span>
              </h2>
              <p>
                Introducing the latest
                <span>Citroën C4</span> series in Ghana. Be amongst the first to test drive this new model.
              </p>
              <div style="margin-top:15%">
                <el-button
                  type="info"
                  style="border: 1.5px solid #BCBCBC;background:transparent"
                  @click="contact"
                >
                  BOOK AN APPOINTMENT
                  <i class="el-icon-arrow-right" style="padding-left:5%"></i>
                </el-button>
                <el-button class="text" type="text" @click="citreon" style="text-transform:uppercase">DISCOVER Citroën</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item> -->

        <!-- <el-carousel-item class="thirdcarousel">
        <div class="container">
          <div class="row">
            <div class="sliderinfo" style="width:550px">
           
              <h2>
                The Peugeot Pick Up
                <span>Robustness Is In Its DNA</span>
              </h2>
              <p style="width: 366px;">
                Introducing the latest
                <span>Peugeot Pick Up</span> series in Ghana. Be amongst the first to test drive this new model.
              </p>
              <div style="margin-top:15%">
                <el-button
                  type="info"
                  style="border: 1.5px solid #BCBCBC;background:transparent"
                  @click="contact"
                >
                  BOOK AN APPOINTMENT
                  <i class="el-icon-arrow-right" style="padding-left:5%"></i>
                </el-button>
                <el-button class="text" type="text" @click="pegeout">DISCOVER PEUGEOT</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item> -->
    </el-carousel>

    <div class="info">
      <div class="container" style="padding-bottom: 3rem;">
        <div class="row">
          <div class="partners py-3">
            <p>
              Our
              <span>exclusive partners</span>, bringing you the best in the industry
            </p>
          </div>
        </div>
        <div class="row normalpat">
          <div class="partnerslogo my-3" style="margin-top:0rem !important">
            <div
              class="col-6 col-md-4 col-lg-4"
              style=" border-right: 1px solid rgba(188, 188, 188, 0.3);padding: 2rem 2rem 2rem 0rem;"
            >
              <div class="partlogo" @click="passenger">
                <div class>
                  <div class="my-3">
                    <img :src="UYU" class="car_logo" width="90px" style="left:10%" />
                  </div>
                  <div class="icon_content">
                    <i class="el-icon-right"></i>
                  
                    <h5>Mercedes-Benz</h5>
                    <p class="pass">Passenger Vehicles</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div
              class="col-6 col-md-3 col-lg-3"
              style=" border-right: 1px solid rgba(188, 188, 188, 0.3);padding: 1.8rem 1.5rem;"
            >
              <div class="partlogo" @click="commercial">
                <div class>
                  <div class="my-3">
                    <img :src="UYU" class="car_logo" width="90px" />
                  </div>
                  <div class="icon_content" style="right: 13%;">
                    <i class="el-icon-right"></i>
                     <h5>Mercedes-Benz</h5>
                    <p class="pass">Commercial Vehicles</p>
                   
                  </div>
                </div>
              </div>
            </div> -->
            <div
              class="col-6 col-md-4 col-lg-4"
              style=" border-right: 1px solid rgba(188, 188, 188, 0.3);padding: 1.8rem 1.5rem;"
            >
              <div class="partlogo" @click="pegeout">
                <div class>
                  <div class="my-3">
                    <img :src="benz" class="car_logo" width="62px" />
                  </div>
                  <div class="icon_content" style="right: 32%;">
                    <i class="el-icon-right"></i>
                    <!-- <p class="pass" style="color:#151515">hhhhh</p> -->
                    <h5>Peugeot</h5>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-6 col-md-4 col-lg-4"
              style=" border-right: 0px solid rgba(188, 188, 188, 0.3);padding: 2rem 0rem 2rem 2rem"
            >
              <div class="partlogo" @click="citreon">
                <div class>
                  <div class="my-3">
                    <img :src="cit" class="car_logo" width="90px" />
                  </div>
                  <div class="icon_content" style="right: 32%;">
                    <i class="el-icon-right"></i>
                    <!-- <p class="pass" style="color:#151515">hhhhh</p> -->
                    <h5>Citroën</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- mobile -->
        <div class="row mobilepat" >
          <div class="partnerslogo my-3" style="margin-top:0rem !important">
            <div
              class="col-12 horc mobbrand"
              style=" border-right: 0px solid rgba(188, 188, 188, 0.3);padding: 10% 15%;"
            >
              <div class="partlogo" @click="passenger">
                <div class>
                  <div class="my-3">
                    <img  :src="UYU"  class="car_logo" width="90px"/>
                  </div>
                  <div class="icon_content">
                    <i class="el-icon-right"></i>
                   
                    <h5>Mercedes-Benz</h5>
                     <p class="pass">Passenger Vehicles</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div
              class="col-12 mobbrand"
              style=" border-right: 0px solid rgba(188, 188, 188, 0.3);padding: 0rem 15% 10% 15%"
            >
              <div class="partlogo" @click="commercial">
                <div class>
                  <div class="my-3">
                    <img :src="UYU"  class="car_logo" width="90px" />
                  </div>
                  <div class="icon_content" style="top:10%">
                    <i class="el-icon-right"></i>
                 
                    <h5>Mercedes-Benz</h5>
                       <p class="pass">Commercial Vehicles</p>
                  </div>
                </div>
              </div>
            </div> -->
            <div
              class="col-12 mobbrand"
              style=" border-right: 0px solid rgba(188, 188, 188, 0.3);padding: 0rem 15% 10% 15%"
            >
              <div class="partlogo" @click="pegeout">
                <div class>
                  <div class="my-3">
                    <img :src="benz"  class="car_logo" width="65px" />
                  </div>
                  <div class="icon_content" style="top:10%;right:39%">
                    <i class="el-icon-right"></i>
                    <!-- <p class="pass" style="color:#151515">hhhhh</p> -->
                    <h5>Peugeot</h5>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-12 mobbrand"
              style=" border-right: 0px solid rgba(188, 188, 188, 0.3);padding:0rem 15% 10% 15%"
            >
              <div class="partlogo" @click="citreon">
                <div class>
                  <div class="my-3">
                    <img :src="cit" class="car_logo" width="90px" />
                  </div>
                  <div class="icon_content" style="top:10%;right:41%">
                    <i class="el-icon-right"></i>
                    <!-- <p class="pass" style="color:#151515">hhhhh</p> -->
                    <h5>Citroën</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container py-5 journey">
          <div class="row">
            <div>
              <h6 class>DISCOVER OUR JOURNEY</h6>
              <h3>As the leading automotive distributor in Ghana</h3>
              <div>
                <p>At Silver Star Auto we are proud of the incredible accomplishments that we’ve undertaken over the years. Here are a few highlights of what we’ve achieved so far</p>
              </div>
            </div>
          </div>
        </div>

        <!-- testing mike one two -->

        <div class="years normaldate">
          <carousel
            :per-page="4"
            :autoplay="true"
            :navigate-to="someLocalProperty"
            :scrollPerPage="false"
            :navigationEnabled="true"
            :paginationEnabled="false"
            :mouse-drag="true"
            :loop="true"
            navigationPrevLabel="<i class='ti-angle-left boxarrow'></i>"
            navigationNextLabel="<i class='ti-angle-right boxarrow'></i>"
          >
            <slide>
              <div class="yline item">
                <div class="dates">
                  <!-- <h6 class>December</h6> -->
                  <div>
                    <h3>1996</h3>
                  </div>
                  <div>
                    <p>Business Incorporation</p>
                  </div>
                </div>
              </div>
            </slide>
            <slide>
              <div class="yline item">
                <div class="dates">
                  <!-- <h6 class>October</h6> -->
                  <div>
                    <h3>2003</h3>
                  </div>
                  <div>
                    <p>Ultra-modern service centre, Tema completed. Workshop operation for Passenger vehicles transferred to Tema.</p>
                  </div>
                </div>
              </div>
            </slide>
            <slide>
              <div class="yline item">
                <div class="dates">
                  <!-- <h6 class>January</h6> -->
                  <div>
                    <h3>2008</h3>
                  </div>
                  <div>
                    <p>Airport City Showroom and offices opened at Silver Star Towers.</p>
                  </div>
                </div>
              </div>
            </slide>
            <slide>
              <div class="yline item">
                <div class="dates">
                  <!-- <h6 class>November</h6> -->
                  <div>
                    <h3>2015</h3>
                  </div>
                  <div>
                    <p>Airport City Showroom and offices opened at Silver Star Towers.</p>
                  </div>
                </div>
              </div>
            </slide>

            <slide>
              <div class="yline item">
                <div class="dates">
                  <!-- <h6 class>November</h6> -->
                  <div>
                    <h3>2016</h3>
                  </div>
                  <div>
                    <p>Acquired distributorship of Suzuki vehicles in Ghana. Opened the Kumasi branch.</p>
                  </div>
                </div>
              </div>
            </slide>
            <slide>
              <div class="yline item">
                <div class="dates">
                  <!-- <h6 class>November</h6> -->
                  <div>
                    <h3>2017</h3>
                  </div>
                  <div>
                    <p>Relocated the head office to Graphic Road and refurbished our Sales and After-Sales facilities.</p>
                  </div>
                </div>
              </div>
            </slide>
            <slide>
              <div class="yline item">
                <div class="dates">
                  <!-- <h6 class>November</h6> -->
                  <div>
                    <h3>2019</h3>
                  </div>
                  <div>
                    <p>Ended our partnership with the Suzuki brand. Acquired the exclusive distributorship of Peugeot and Citroën brands in Ghana.</p>
                  </div>
                </div>
              </div>
            </slide>
             <slide>
              <div class="yline item">
                <div class="dates">
                  <!-- <h6 class>November</h6> -->
                  <div>
                    <h3>2022</h3>
                  </div>
                  <div>
                    <p>Silver Star Auto in collaboration with Peugeot PSA begins assembling of 3008 SUV and 4x4 Landtrek models in Ghana.</p>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
        <!-- mobiledateslider -->
          <!-- testing mike one two -->

        <div class="years mobiledate" style="display:none">
          <carousel
            :per-page="2"
            :autoplay="true"
            :navigate-to="someLocalProperty"
            :scrollPerPage="false"
            :navigationEnabled="true"
            :paginationEnabled="false"
            :mouse-drag="true"
            :loop="true"
            navigationPrevLabel=""
            navigationNextLabel=""
          >
            <slide>
              <div class="yline item">
                <div class="dates">
                  <!-- <h6 class>December</h6> -->
                  <div>
                    <h3>1996</h3>
                  </div>
                  <div>
                    <p>Business Incorporation</p>
                  </div>
                </div>
              </div>
            </slide>
            <slide>
              <div class="yline item">
                <div class="dates">
                  <!-- <h6 class>October</h6> -->
                  <div>
                    <h3>2003</h3>
                  </div>
                  <div>
                    <p>Ultra-modern service centre, Tema completed. Workshop operation for Passenger vehicles transferred to Tema.</p>
                  </div>
                </div>
              </div>
            </slide>
            <slide>
              <div class="yline item">
                <div class="dates">
                  <!-- <h6 class>January</h6> -->
                  <div>
                    <h3>2008</h3>
                  </div>
                  <div>
                    <p>Airport City Showroom and offices opened at Silver Star Towers.</p>
                  </div>
                </div>
              </div>
            </slide>
            <slide>
              <div class="yline item">
                <div class="dates">
                  <!-- <h6 class>November</h6> -->
                  <div>
                    <h3>2015</h3>
                  </div>
                  <div>
                    <p>Airport City Showroom and offices opened at Silver Star Towers.</p>
                  </div>
                </div>
              </div>
            </slide>

            <slide>
              <div class="yline item">
                <div class="dates">
                  <!-- <h6 class>November</h6> -->
                  <div>
                    <h3>2016</h3>
                  </div>
                  <div>
                    <p>Acquired distributorship of Suzuki vehicles in Ghana. Opened the Kumasi branch.</p>
                  </div>
                </div>
              </div>
            </slide>
            <slide>
              <div class="yline item">
                <div class="dates">
                  <!-- <h6 class>November</h6> -->
                  <div>
                    <h3>2017</h3>
                  </div>
                  <div>
                    <p>Relocated the head office to Graphic Road and refurbished our Sales and After-Sales facilities.</p>
                  </div>
                </div>
              </div>
            </slide>
            <slide>
              <div class="yline item">
                <div class="dates">
                  <!-- <h6 class>November</h6> -->
                  <div>
                    <h3>2019</h3>
                  </div>
                  <div>
                    <p>Ended our partnership with the Suzuki brand. Acquired the exclusive distributorship of Peugeot and Citroën brands in Ghana.</p>
                  </div>
                </div>
              </div>
            </slide>
            <slide>
              <div class="yline item">
                <div class="dates">
                  <!-- <h6 class>November</h6> -->
                  <div>
                    <h3>2022</h3>
                  </div>
                  <div>
                    <p>Silver Star Auto in collaboration with Peugeot PSA begins assembling of 3008 SUV and 4x4 Landtrek models in Ghana.</p>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
    </div>

    <!-- discover -->
    <div class="discover">
      <div class="container">
        <div class="col-md-12" style="padding-top: 1.5rem;">
          <div class="text-center py-5">
            <h3 class="discover_title" style="font-size: 20px;">
              <span>DISCOVER SILVER STAR AUTO</span>
            </h3>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 col-md-3 col-lg-3" @click="peugeot">
            <div class="box">
              <img :src="car1" width="100%" height="100%" />
            </div>
            <div class="boxcontent">
              <h6 class="py-3">EXCITING NEW MODELS</h6>
              <p>Check out the all-new Peugeot models, and enhance your experience while being in control of the new PEUGEOT i-Cockpit®.</p>
            </div>
          </div>

          <div class="col-sm-6 col-md-3 col-lg-3" @click="book">
            <div class="box">
              <img :src="car2" width="100%" height="100%" />
            </div>
            <div class="boxcontent">
              <h6 class="py-3">BOOK A TEST DRIVE ONLINE</h6>
              <p>Experience our new vehicles by booking a test drive appointment online. Simply enter your contact details and the brand and model of your choice</p>
            </div>
          </div>

          <div class="col-sm-6 col-md-3 col-lg-3" @click="afterservice">
            <div class="box">
              <img :src="car3" width="100%" height="100%" style="object-position: 60% 30%;" />
            </div>
            <div class="boxcontent">
              <h6 class="py-3">AT YOUR SERVICE</h6>
              <p>Visit our service centres in Accra, Tema and Kumasi for quick and reliable after-sales support. Services include express and routine maintenance, towing, and breakdown repairs</p>
            </div>
          </div>

          <div class="col-sm-6 col-md-3 col-lg-3" @click="promotion">
            <div class="box">
              <img :src="car4" width="100%" height="100%" />
            </div>
            <div class="boxcontent">
              <h6 class="py-3">LIMITED-TIME OFFERS</h6>
              <p>Keep up with new promotions from Peugeot, Citroën, and Mercedes-Benz</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- book a test drive -->
    <div class="booktest">
      <div class="container">
        <div class="row">
          <div class="booktest_content">
            <h5 class="booktest_title">BOOK A TEST DRIVE NOW</h5>

            <p
              class="booktest_info py-3"
            >Refined, composed and a pleasure to drive. Experience it for yourself by booking an appointment with your nearest Silver Star Auto Retailer at a time that suits you.</p>
            <el-button type="info" @click="contact">
              BOOK AN APPOINTMENT
              <i class="el-icon-arrow-right" style="padding-left:5%"></i>
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- core -->
    <div class="bg-dark" style="padding-top:3rem">
      <div class="container">
        <core style="border-top:1px solid rgba(255, 255, 255, .24)"></core>
      </div>
    </div>
  </div>
</template>
<noscript>												
  <p style="margin:0;padding:0;border:0;">												
      <img src="https://a1.adform.net/Serving/TrackPoint/?pm=2867926&ADFPageName=Ghana%20Silverstar%20Main&ADFdivider=|" width="1" height="1" alt="" />												
  </p>												
</noscript>
<script>

import axios from "axios";
import { Carousel, Slide } from "vue-carousel";

import CoreValues from "../components/Core.vue";
// import { VueperSlides, VueperSlide } from 'vueperslides'
// import 'vueperslides/dist/vueperslides.css';
var car1 = require("../assets/img/home_SUV.jpeg");
var car2 = require("../assets/img/car2.png");
var car3 = require("../assets/img/newcar.jpg");
var car4 = require("../assets/img/car3.png");
var cit = require("../assets/img/Cit.png");
var benz = require("../assets/img/benz.png");
var UYU = require("../assets/img/UYU.png");

export default {
  name: "home",
  components: {
    core: CoreValues,

    Slide
    //VueperSlides, VueperSlide
  },
  data() {
    return {
      
      car1: car1,
      car2,
      car3,
      car4,
      cit: cit,
      benz: benz,
      UYU: UYU,
      ready: {
        currentSlide: { index: 0, title: "1", content: "", image: "", link: "" }
      },
      homebrand: [],
      slider:[],
      slidername:[],
      
    };
  },
  metaInfo() {
    return {
      title: "Home"
    };
  },
  computed: {},
  methods: {
    contact() {
      this.$router.push("/contact");
    },
    citreon() {
      this.$router.push("/citroen");
    },
    commercial() {
      this.$router.push("/mercedes/commercial");
    },
    passenger() {
      this.$router.push("/mercedes/passenger");
    },
   peugeot() {
      this.$router.push("/peugeot");
    },
    book() {
      this.$router.push("/book");
    },
    afterservice() {
      this.$router.push("/aftersales");
    },
    promotion() {
      this.$router.push("/promotion");
    },
    // fetch_homebrand() {
    //   var self = this;

    //   axios.get(APIURL + "homepromotion").then(response => {
    //     this.homebrand = response.data.data;
    //     console.log(this.homebrand);
    //   });
    // },
    collectslide(){
       var self = this;

      axios.get(APIURL + "sliderindex").then(response => {
        this.slider = response.data.data;
        this.slidername = this.slider.name
        console.log(this.slider);
         console.log("in the api method "+this.slidername);
      });
    },
      pegeout() {
        console.log("in the method "+this.slidername);
      // this.$router.push("/"+this.slidername);
       this.$router.push("/peugeot");
    }
  },
  created() {
    // this.fetch_homebrand();
    this.collectslide();
  },mounted(){
    let externalScript = document.createElement('script')
    window._adftrack = Array.isArray(window._adftrack) ? window._adftrack : (window._adftrack ? [window._adftrack] : []);												
	    window._adftrack.push({												
	        HttpHost: 'a1.adform.net',												
	        pm: 2867926,												
	        divider: encodeURIComponent('|'),												
	        pagename: encodeURIComponent('Ghana Silverstar Main')												
	    });												
	    (function () { var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://s2.adform.net/banners/scripts/st/trackpoint-async.js'; var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); return true })();	
  }
};
</script>
